import React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { Pagination as UiPagination } from '@/ui/navigation/pagination'

interface PaginationProps {
  currentPage: number
  totalItems: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
  disabled?: boolean
  pageSizeOptions?: number[]
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  pageSize,
  onPageChange,
  onPageSizeChange,
  disabled = false,
  pageSizeOptions = [10, 20, 50, 100],
}) => {
  const { tSafe } = useLocalize()

  return (
    <UiPagination 
      currentPage={currentPage}
      totalRecords={totalItems}
      pageSize={pageSize}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      disabled={disabled}
      pageSizeOptions={pageSizeOptions}
      t={tSafe}
    />
  )
}
